<template>
  <div>
    <v-row>
      <v-col cols="6" class="mt-n3 pb-0 mb-n4">
        <CommonDropDowns :isItTaxYearWithoutAllYears=true :taxYearValue="editedItem.taxYear"
          :isTaxYearWithoutAllDisabled="true" />
      </v-col>
      <v-col cols="6" class="pb-0 mb-n4">
        <v-text-field class="input-text-size pa-0 pt-1" :value="editedItem.taxId" readonly tabindex="-1" dense
        label="Tax ID" />
      </v-col>
      <v-col cols="6" class="pb-0 mb-n4">
        <v-text-field class="input-text-size pa-0 pt-1" :value="editedItem.userName" readonly tabindex="-1" dense
        label="Username" />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4 mt-n2">
        <CommonDropDowns :isItCategory=true @change="dataFromCommonDropDowns"
          :commentsCategoryValue="editedItem.category" :isCommentsCategoryDisabled="true" />
      </v-col>
      <v-col cols="6" class="pt-2 pb-0 mb-n4 mt-n2">
        <v-autocomplete :items="reasonListDropDown" class="input-text-size" label='Reason Code'
         v-model="editedItem.reasonCode" item-text="name" item-value="value"
         :rules="rulesForEmptyDropdown" />
      </v-col>
      <v-col cols="4" class="pt-2 pb-0">
          <v-checkbox v-model="editedItem.addToLegal" class="input-text-size"
          :value="editedItem.addToLegal ? true : false" label="Add To Legal on Statement"
          :disabled="isItCommentSeven" />
      </v-col>
      <v-col cols="4" class="pl-2 pa-0 mt-4">
        <v-checkbox class="input-text-size" v-model="editedItem.sendToWebsite"
        :value="editedItem.sendToWebsite ? true : false" label="Send To Website"
        :disabled="isItCommentSeven" />
      </v-col>
      <v-col cols="4" class="pl-2 pa-0 mt-10">
        <v-checkbox class="input-text-size mt-n2" v-model="editedItem.rollToNextYear"
        :value="editedItem.rollToNextYear ? true : false" label="Roll To Next Year"
        :disabled="isItCommentSeven" />
      </v-col>
      <v-col cols="12">
        <v-textarea class="input-text-size pa-0 mb-n5" outlined rows="3"
         :class="{ 'locked-textarea': isItCommentSeven }"
         v-model="editedItem.comment" :autofocus="true" :readonly="isItCommentSeven"
         :auto-grow="isItCommentSeven"
          v-textAreaUppercase=globalSettingItem.conEverythingToCaps>
          <template v-slot:label>
            <label>Comments</label>
          </template>
        </v-textarea>
      </v-col>
      <v-col v-if="isOwnerInfoCategory" cols="6" class="pt-2 pb-0 mb-n4">
        <v-textarea class="input-text-size mailing-address-textarea" outlined auto-grow
         :class="{ 'locked-textarea': isItCommentSeven }"
         v-model="editedItem.beforeChange" label="Mailing Address Before"
         :readonly="isItCommentSeven"
         v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
      </v-col>
      <v-col v-if="isOwnerInfoCategory" cols="6" class="pt-2 pb-0 mb-n4">
        <v-textarea class="input-text-size mailing-address-textarea" outlined auto-grow
         :class="{ 'locked-textarea': isItCommentSeven }"
         v-model="editedItem.afterChange" label="Mailing Address After"
         :readonly="isItCommentSeven"
         v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import { canModifyUserComment, taxCommentTypesObj } from '../common-utils/tax-common.util';
import { authRoles } from '../../../router/roleGroups';
import { isAuthorised } from '../../../store/auth/token';

export default {
  name: 'commentDialog',
  mixins: [GlobalToCaps],
  components: {
    CommonDropDowns,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxComments',
    },
    isItFromCommentList: {
      type: Boolean,
      default: false,
    },
    category: Number,
  },
  data() {
    return {
      selected: true,
    };
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items', 'index', 'isVisible']),
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      commentsCategory: (state) => state.tax.taxComments.commentsCategory,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    rulesForEmptyDropdown() {
      return [
        (v) => {
          if (this.taxSettingItem.makeReasonCodeRequired && !this.isItFromCommentList) return !!v || 'Required.';
          return true;
        },
      ];
    },
    // True means LOCKED (readonly), not 'this is a category 7 comment' - the name predates the
    // rule it carries. Opened from the comment list, everything except a category-7 comment is
    // read-only, and a category-7 comment is read-only too unless it is yours.
    isItCommentSeven() {
      if (!this.isItFromCommentList) return false;
      if (taxCommentTypesObj.userCommentCode !== this.editedItem.category) return true;
      return !this.canEditThisComment;
    },
    isTmAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
    canEditThisComment() {
      // No _id = a comment being created, so it is nobody else's yet. The 'Create Comment'
      // dialogs on Taxroll/Owner Search also pass isItFromCommentList and open a category-7
      // item with no userName at all - without this they would open locked.
      if (!this.editedItem._id) return true;
      return canModifyUserComment(this.editedItem, this.authUser, this.isTmAdmin);
    },
    isOwnerInfoCategory() {
      return this.editedItem.category === taxCommentTypesObj.ownerInfoCode;
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
  },
};
</script>

<style scoped>
.mailing-address-textarea ::v-deep .v-textarea__textarea,
.mailing-address-textarea ::v-deep textarea {
  letter-spacing: -0.2px;
  line-height: 1.3;
}

/* Converted / non-user comments are readonly rather than disabled so the full
   text stays scrollable and selectable. Keep the locked look via CSS, and cap
   the auto-grow height so very long comments scroll instead of stretching
   the dialog. */
.locked-textarea ::v-deep textarea {
  max-height: 40vh;
  overflow-y: auto;
  cursor: default;
}
.locked-textarea ::v-deep .v-input__slot {
  background-color: rgba(0, 0, 0, 0.04);
}
.locked-textarea.theme--dark ::v-deep .v-input__slot {
  background-color: rgba(255, 255, 255, 0.06);
}
</style>
